import { sendReceivePresentationUpdateAnalytic } from '../../utils/analytics';

const analytics = (socket) => {
  const onPresentationSessionUpdated = ({
    spaceId,
    id: presentationId,
    instanceId: presentationSessionId,
    correlationId,
  }) => {
    sendReceivePresentationUpdateAnalytic({
      spaceId,
      presentationId,
      presentationSessionId,
      correlationId,
    });
  };

  socket.on('Presentation:SessionUpdated', onPresentationSessionUpdated);
};

export default analytics;
